@if (isRebranding()) {
<div class="tw-flex tw-flex-row tw-items-start tw-gap-4 tw-pt-8">
     <div id="face-section"
          class="tw-w-1/2 tw-relative tw-flex-1 tw-bg-gray-80 tw-pb-8 tw-px-[13px] tw-pt-20 tw-rounded-2.5 tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.1)]"
          (click)="onSelectConcern(appConfig.Shared.Regimen.Class.FACE)">
          <img class="tw-absolute tw-block tw-h-[90px]"
               style="top: -28px;"
               [src]="faceIconUrl"
               alt="face"/>
          <div class="tw-flex tw-flex-col tw-gap-1 tw-mb-6">
               <p class="tw-font-body tw-font-bold tw-text-500 tw-text-[20px] tw-text-gray-800"><span
                          i18n="@@face">Face</span>
               </p>
               <p class="tw-text-300"
                  i18n="@@reachYourSkinGoals">Reach your <br /> skin goals</p>
          </div>
          <div
               class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-2 tw-bg-teal-600 tw-rounded-3 tw-py-2 tw-pr-2 tw-text-white xxs:tw-text-nowrap xxs:tw-pl-2 xs:tw-pl-4">
               <p class="tw-text-300 tw-font-bold"
                  i18n="@@clickHere">Click Here</p>
               <svg xmlns="http://www.w3.org/2000/svg"
                    viewBox="16.5 12 14 24"
                    width="7"
                    height="12">
                    <path fill="white"
                          d="m18.75 36-2.15-2.15 9.9-9.9-9.9-9.9 2.15-2.15L30.8 23.95Z" />
               </svg>
          </div>
     </div>
     <div id="hair-section"
          class="tw-w-1/2 tw-relative tw-flex-1 tw-bg-gray-80 tw-pb-8 tw-px-4 tw-pt-20 tw-rounded-2.5 tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.1)]"
          (click)="onSelectConcern(appConfig.Shared.Regimen.Class.HAIR)">
          <img class="tw-absolute tw-block tw-h-[90px]"
               style="top: -28px;"
               [src]="hairIconUrl"
               alt="hair icon"/>
          <div class="tw-flex tw-flex-col tw-gap-1 tw-mb-6">
               <p class="tw-font-body tw-font-bold tw-text-500 tw-text-[20px] tw-text-gray-800"><span
                          i18n="@@hair">Hair</span>
               </p>
               <p class="tw-text-300"
                  i18n="@@achieveBetterHair">Achieve <br /> better hair</p>
          </div>
          <div
               class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-2 tw-bg-teal-600 tw-rounded-3 tw-py-2  tw-pr-2 tw-text-white xxs:tw-text-nowrap xxs:tw-pl-2 xs:tw-pl-4">
               <p class="tw-text-300 tw-font-bold"
                  i18n="@@clickHere">Click Here</p>
               <svg xmlns="http://www.w3.org/2000/svg"
                    viewBox="16.5 12 14 24"
                    width="7"
                    height="12">
                    <path fill="white"
                          d="m18.75 36-2.15-2.15 9.9-9.9-9.9-9.9 2.15-2.15L30.8 23.95Z" />
               </svg>
          </div>
     </div>
</div>
} @else {
<div class="tw-flex tw-flex-row tw-items-start tw-gap-6 tw-pt-14 tw-px-6 tw-pb-6 tw-min-h-[400px]">
     <div id="face-section"
          class="tw-relative tw-flex-1 tw-bg-gray-80 tw-pb-8 tw-px-4 tw-pt-20 tw-rounded-2.5 tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.1)]"
          [ngClass]='{ "tw-order-1": concernClass() === appConfig.Shared.Regimen.Class.HAIR }'
          (click)="onSelectConcern(appConfig.Shared.Regimen.Class.FACE)">
          <img class="tw-absolute tw-block tw-h-[90px]"
               style="top: -28px;"
               [src]="faceIconUrl" 
               alt="face icon"/>
          @if (acqRebranding2025()) {
          <div class="tw-font-lexend tw-text-500 tw-text-[20px] tw-text-gray-800 tw-mb-6"
               i18n="@@forSkinBold"> For <b>skin</b> problems </div>
          } @else {
          <div class="tw-font-body tw-font-bold tw-text-500 tw-text-[20px] tw-text-gray-800 tw-mb-6"
               i18n="@@forSkin"> For skin problems </div>
          }
          @if (acqRebranding2025()) {
          <button csButton
                  size="small"
                  type="button"
                  i18n="@@clickHere">Click Here</button>
          } @else {
          <cs-button [class]="'tw-w-full primary btn-xxxs'">
               <cs-button-text i18n="@@clickHere">Click Here</cs-button-text>
               <cs-icon class="tw-h-4 tw-w-4"
                        [iconName]='"chevron_right"'></cs-icon>
          </cs-button>
          }
     </div>
     <div id="hair-section"
          class="tw-relative tw-flex-1 tw-bg-gray-80 tw-pb-8 tw-px-4 tw-pt-20 tw-rounded-2.5 tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.1)]"
          (click)="onSelectConcern(appConfig.Shared.Regimen.Class.HAIR)">
          <img class="tw-absolute tw-block tw-h-[90px]"
               style="top: -28px;"
               [src]="hairIconUrl"
               alt="hair icon"/>
          @if (acqRebranding2025()) {
          <div class="tw-font-lexend tw-text-500 tw-text-[20px] tw-text-gray-800 tw-mb-6"
               i18n="@@forHairBold"> For <b>hair</b> problems </div>
          } @else {
          <div class="tw-font-body tw-font-bold tw-text-500 tw-text-[20px] tw-text-gray-800 tw-mb-6"
               i18n="@@forHair"> For hair problems </div>
          }
          @if (acqRebranding2025()) {
          <button csButton
                  size="small"
                  type="button"
                  i18n="@@clickHere">Click Here</button>
          } @else {
          <cs-button [class]="'tw-w-full primary btn-xxxs'">
               <cs-button-text i18n="@@clickHere">Click Here</cs-button-text>
               <cs-icon class="tw-h-4 tw-w-4"
                        [iconName]='"chevron_right"'></cs-icon>
          </cs-button>
          }
     </div>
</div>
}